export default __webpack_public_path__ + "static/media/pompe.bb6463ce.jpg";